<template>
  <section
    id="our-product"
    class="flex flex-col mt-10 px-10 pt-10 bg-qwraylight"
  >
    <template v-if="isMobile">
      <custom-scroller v-bind:scrollerItems="scrollerItems" />
    </template>
    <template v-else>
      <custom-scroller-desktop v-bind:scrollerItems="scrollerItems" />
    </template>
  </section>
</template>
<script>
import { entity } from '@/../region.json';
import CustomScroller from './CustomScroller.vue';
import CustomScrollerDesktop from './CustomScrollerDesktop.vue';
import getOurProductScrollerItemsByEntity from '../../../shared/entitySpecificData';

export default {
  name: 'OurProduct',
  components: {
    CustomScroller,
    CustomScrollerDesktop,
  },
  data() {
    return {
      isMobile: false,
      scrollerItems: getOurProductScrollerItemsByEntity(entity, this.$i18n),
    };
  },
  methods: {
    onScreenResize() {
      if (window.innerWidth <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile) {
        this.isMobile = false;
      }
    },
  },
  beforeMount() {
    this.isMobile = window.innerWidth < 768;
  },
  mounted() {
    // Must be run on mount after checking for localStorage in 'beforeMount' lifecycle
    window.addEventListener('resize', this.onScreenResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScreenResize);
  },
};
</script>

<style>
.background-yellow {
  background-image: url('~@/assets/bg-yellow-mobile.svg');
  width: 2/3;
  background-repeat: no-repeat;
}
.background-gray {
  background-image: url('~@/assets/bg-yellow-mobile.svg');
  background-repeat: no-repeat;
  background-position: right bottom;
}
</style>
